<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-form ref="form" @submit="validateAndSubmit" onSubmit="return false;">
          <v-card>
            <v-card-title>
              <h2>Forgot your password?</h2>
            </v-card-title>
            <v-card-text>
              No problem, we'll reset it for you.

              <v-text-field
                type="email"
                class="input_field"
                v-model="mail"
                :rules="mail_rules"
                label="Your E-Mail Address"
              ></v-text-field>
            </v-card-text>

            <v-card-actions>
              <v-btn class="primary" type="this.alert_type"
                >Reset Password</v-btn
              >

              <v-btn
                v-if="show_login_button"
                style="margin-right: 16px; margin-left: auto"
                left
                color="orange darken-1"
                dark
                v-on:click="go_to_login"
              >
                Go To Login <v-icon dark right>arrow_forward</v-icon>
              </v-btn>
            </v-card-actions>

            <v-alert
              :value="show_alert"
              :type="alert_type"
              transition="scale-transition"
              >{{ alert_text }}</v-alert
            >

            <v-progress-linear
              v-if="show_loading"
              :indeterminate="true"
            ></v-progress-linear>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/* global firebase */
export default {
  name: "Reset_Password",
  data() {
    return {
      show_login_button: false,
      alert_text: "",
      alert_type: "success",
      show_alert: false,
      mail_rules: [v => !!v || "E-Mail cannot be empty!"],
      show_loading: false,
      mail: null
    };
  },
  methods: {
    async validateAndSubmit() {
      if (this.$refs.form.validate()) {
        this.show_alert = false;
        this.show_login_button = false;
        this.show_loading = true;
        firebase
          .auth()
          .sendPasswordResetEmail(this.mail)
          .then(() => {
            this.alert_text = "Sent Password Reset E-Mail";
            this.alert_type = "success";
            this.show_alert = true;
            this.show_loading = false;
            this.show_login_button = true;
          })
          .catch(() => {
            this.alert_text = "Could Not Send Password Reset E-Mail";
            this.alert_type = "error";
            this.show_alert = true;
            this.show_loading = false;
            this.show_login_button = false;
          });
      }
    },
    go_to_login() {
      this.$router.push("/signin");
    }
  }
};
</script>

<style scoped></style>
